import { defineMessages } from 'react-intl';

export default defineMessages({
    nextStepText: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.We\'ll review for any additional activity next and MVRs may be run',
        defaultMessage: 'We\'ll review for any additional activity next and MVRs may be run'
    },
    driver: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Driver',
        defaultMessage: 'Driver'
    },
    drivers: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Drivers',
        defaultMessage: 'Drivers'
    },
    excludedDriver: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Excluded Driver',
        defaultMessage: 'Excluded Driver'
    },
    excludedDrivers: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Excluded Drivers',
        defaultMessage: 'Excluded Drivers'
    },
    householdMember: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Household Member',
        defaultMessage: 'Household Member'
    },
    householdMembers: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Household Members',
        defaultMessage: 'Household Members'
    },
    vehicleNumber: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Vehicle Number',
        defaultMessage: 'Vehicle #{vehicleNumber}'
    },
    driverNumber: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Driver Number',
        defaultMessage: 'Driver #{driverNumber}'
    },
    householdMemberNumber: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Household Member Number',
        defaultMessage: 'Household Member #{householdMemberNumber}'
    },
    excludedDriverNumber: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Excluded Driver Number',
        defaultMessage: 'Excluded Driver #{excludedDriverNumber}'
    },
    watercraftOperatorNumber: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Watercraft Operator Number',
        defaultMessage: 'Watercraft Operator #{watercraftOperatorNumber}'
    },
    vinRequired: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.VIN required. Must be 17 digits if 1981 and newer.',
        defaultMessage: 'VIN required. Must be 17 digits if 1981 and newer.'
    },
    serialNumber: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Serial Number',
        defaultMessage: 'Serial Number'
    },
    enterSerialNumber: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Enter Serial Number',
        defaultMessage: 'Enter Serial Number'
    },
    emailAddress: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Email Address',
        defaultMessage: 'Email Address'
    },
    enterEmailAddress: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Enter Email Address',
        defaultMessage: 'Enter Email Address'
    },
    nextDescription: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.nextDescription',
        defaultMessage: 'We\'ll {review} next and {mvr}'
    },
    reviewForAnyAdditionalActivity: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.review for any additional activity',
        defaultMessage: 'review for any additional activity'
    },
    mVRsMayBeRun: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.MVRs may be run',
        defaultMessage: 'MVRs may be run'
    },
    liabilityLossQuestion: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Have there been any umbrella or personal liability losses in the last 5 years?',
        defaultMessage: 'Have there been any umbrella or personal liability losses in the last 5 years?'
    },
    errorOccured: {
        id: 'ml.endorsement.pa.directives.templates.errorOccured',
        defaultMessage: 'An error has occurred which may prevent you from completing your quote. If you are unable to continue past this page, please contact customer service for assistance using the chat feature.',
    },
    invalidEmail:{
        id:'ml.endorsement.pa.directives.templates.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    verifyEmail:{
        id:'ml.endorsement.pa.directives.templates.verifyEmail',
        defaultMessage:"Enter a valid email address"
    },
    duplicateLicenseError:{
        id:'ml.endorsement.pa.directives.templates.License numbers must be unique.',
        defaultMessage:"License numbers must be unique."
    },
    somethingWentWrong: {
        id: 'ml.endorsement.pa.directives.Something went wrong during this process.  Please try again.',
        defaultMessage: 'Something went wrong during this process.  Please try again.'
    },
    OriginalEffectiveDate: {
        id: 'ml.quoteandbind.common.additionalinfo.OrioginalEffectiveDate',
        defaultMessage: 'Please enter a valid date in a MM/YYYY format for the Original Effective Date of your prior policy.'
    },
    FutureEffectiveDate: {
        id: 'ml.quoteandbind.common.additionalinfo.FutureEffectiveDate',
        defaultMessage: 'Original Effective Date of your prior policy cannot be greater than current date.'
    },
    NoCarrierError: {
        id: 'ml.quoteandbind.common.additionalinfo.NoCarrier',
        defaultMessage: 'Please select current carrier.'
    },
    CurrentCompany: {
        id: 'ml.quoteandbind.common.additionalinfo.currentCompany',
        defaultMessage: 'Please select current company.'
    },
    CompanyPolicyNumber: {
        id: 'ml.quoteandbind.additionalinfo.CompanyPolicyNumber',
        defaultMessage: 'Company Policy Number should be less than 25 characters long and be strictly alphanumeric.'
    },
    InvalidInsuranceProviderForBookRoll: {
        id: 'ml.quoteandbind.common.additionalinfo.InvalidInsuranceProviderForBookRoll',
        defaultMessage: 'Prior Insurance Provider is not valid for the Book Roll Type combination'
    },
    umUimHeader: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.umUimHeader',
        defaultMessage: 'Uninsured Motorist/Underinsured Motorist Coverages'
    },
    umUimText: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.umUimText',
        defaultMessage: 'Uninsured/Underinsured Motorist coverage will pay for damages that you, the insured, are legally entitled to recover as a result of injuries caused by a driver who has no Bodily Injury Liability, or by a driver who has Bodily Injury Liability limits which are lower than the Uninsured Motorist limits provided by your policy.'
    },
    isUmUimAvailed: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.isUmUimAvailed',
        defaultMessage: 'For an additional charge, do you want UM/UIM coverage?'
    },
    isUmUimOnAllAutoPolicies: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.isUmUimOnAllAutoPolicies',
        defaultMessage: 'If yes: Do all underlying Auto policies carry UM/UIM coverage?'
    },
    isUmUimLimitsEqualAutoLimits: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.isUmUimLimitsEqualAutoLimits',
        defaultMessage: 'Are those UM/UIM limits equal to the Auto Liability Limits?'
    },
    umUimULAutoPoliciesHardStopErrorMessage: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.umUimULAutoPoliciesHardStopErrorMessage',
        defaultMessage: 'Excess UM/UIM has been requested on the Umbrella policy and all underlying Auto policies must carry UM/UIM coverage to have Excess UM/UIM.'
    },
    umUimULAutoLimitsHardStopErrorMessage: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.umUimULAutoLimitsHardStopErrorMessage',
        defaultMessage: 'Excess UM/UIM has been requested on the Umbrella policy and all underlying Auto policies must carry UM/UIM coverage equal to the Auto Liability limits to have Excess UM/UIM.'
    },
    esignRequiredErrorMessage: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.esignRequiredErrorMessage',
        defaultMessage: 'E-Sign is required.'
    },
    esignOptionRequiredErrorMessage: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.esignOptionRequiredErrorMessage',
        defaultMessage: 'E-Sigature options is required.'
    },
    mobileNumberRequiredErrorMessage: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.mobileNumberRequiredErrorMessage',
        defaultMessage: 'Mobile Number  is required.'
    },
    requiredFieldEsignAck: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.requiredFieldEsignAck',
        defaultMessage: 'Text Acknowledgement is required when esignature options is selected as "Text"'
    },
    invalidMobileNumber: {
        id: 'ml.producerengage.pup.additionalInformationToPurchase.Invalid mobile number',
        defaultMessage: 'Enter a valid US mobile number with 10 digits'
    },

});
